import {
    SectionListWithDotCarousel,
    ShimmerActiveHwCard,
    deserify,
    getLocalStorage,
    isProjectDeadlinePassed,
    theme,
    useCommonServiceClientContext,
} from "@geneo2-web/shared-ui";
import ProjectInfoCardWithGroups from "../../../components/ProjectInfoCardWithGroups";
import { Box, useMediaQuery } from "@mui/material"
import { AssessmentEnum, ModeOfConductionEnum } from "@protos/learning_management/lms.db_pb";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../reduxStore/reduxHooks";
import { Project_Dashboard, View_Project } from "../../../routeHandling/RoutesNomenclature";
import { HomeworkListShimmer } from "../shimmer";

const HomeProjectList = () => {
    const maxItemToShow = 20;
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();
    const teacher_profile_id = getLocalStorage('userId');
    const { class_subject_info } = deserify(
        useAppSelector((state) => state.homeDashboard)
    );
    const { LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler } =
        useCommonServiceClientContext();

    const [projects, setProjects] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    /** The deadline decides the section a project belongs to. */
    const activeProjects = projects.filter(
        (project) => !isProjectDeadlinePassed(project?.assessmentTargetDate)
    );
    const completedProjects = projects.filter((project) =>
        isProjectDeadlinePassed(project?.assessmentTargetDate)
    );

    const getProjectList = async (teacherId: string) => {
        try {
            setLoading(true);
            setError(false);
            const response =
                await LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler.getTeacherAssessmentsList(
                    {
                        teacherId: BigInt(teacherId),
                        subjectId: class_subject_info?.subjectId,
                        sectionId: class_subject_info?.sectionId,
                        pageNumber: 1,
                        assessmentType: AssessmentEnum.ASSESSMENT_PROJECT,
                        modeOfConduction:
                            ModeOfConductionEnum.MODE_OF_CONDUCTION_UNDEFINED,
                    }
                );
            const data = response.assessmentList?.assessmentList;
            if (data) {
                setProjects([...(data.assigned || []), ...(data.ended || [])]);
            } else {
                setProjects([]);
                setError(true);
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            setError(true);
            setProjects([]);
            console.log(err);
        }
    };

    useEffect(() => {
        if (teacher_profile_id) {
            getProjectList(teacher_profile_id);
        }
    }, [class_subject_info?.sectionId, class_subject_info?.subjectId]);

    return loading ? (
        <HomeworkListShimmer children={ProjectShimmerArray} />
    ) : (
        <Box>
            <SectionListWithDotCarousel
                noContentMessage="No Active Projects"
                isError={error}
                containerMdWidth="1214"
                itemsToShow={isMobile ? 1 : 3}
                maxItemsToShow={maxItemToShow}
                title="Active Projects"
                linkButtonHandler={() =>
                    navigate(Project_Dashboard, {
                        state: { assessmentState: 'Assigned' },
                    })
                }
                linkButtonText="See All"
                totalNoOfItems={activeProjects.length}
                items={activeProjects.slice(0, maxItemToShow).map((project, index) => (
                    <ProjectInfoCardWithGroups
                        key={String(project?.assessmentId ?? index)}
                        project={project as any}
                        onClick={() => navigate(`${View_Project}/${project.assessmentId}`)}
                    />
                ))}
            />
            <SectionListWithDotCarousel
                noContentMessage="No Completed Projects"
                isError={error}
                containerMdWidth="1214"
                itemsToShow={isMobile ? 1 : 3}
                maxItemsToShow={maxItemToShow}
                title="Completed Projects"
                linkButtonHandler={() =>
                    navigate(Project_Dashboard, {
                        state: { assessmentState: 'Ended' },
                    })
                }
                linkButtonText="See All"
                totalNoOfItems={completedProjects.length}
                items={completedProjects
                    .slice(0, maxItemToShow)
                    .map((project, index) => (
                        <ProjectInfoCardWithGroups
                            key={String(project?.assessmentId ?? index)}
                            project={project as any}
                            onClick={() => navigate(`${View_Project}/${project.assessmentId}`)}
                        />
                    ))}
            />
            {/* <AssessmentTopicPopup
        assessment={selectedHomework}
        open={chapterListPopup}
        handleClose={() => setChapterListPopup(false)}
      /> */}
        </Box>
    )
}

const ProjectShimmerArray = [
    <ShimmerActiveHwCard key={1} variant="large" />,
    <ShimmerActiveHwCard key={2} variant="large" />,
];

export default HomeProjectList
